<template>
  <div class="side-menu-wrapper">
    <slot></slot>
    <Menu style="height: 70px!important;line-height: 70px;background-color: #000c17!important;" mode="horizontal" ref="menu" v-show="!collapsed" :active-name="activeName" :open-names="openedNames" :accordion="accordion" :theme="theme" width="auto" @on-select="handleSelect">
      <div class="layout-logo">
<!--        <div style="width:40%;height:100%;background-color:#284B63;margin-left: 5%;text-align: center;line-height: 70px ">放logo</div>-->
      </div>
      <div>
        <template v-for="item in menuList">
          <template v-if="item.children && item.children.length === 1">
            <side-menu-item v-if="showChildren(item)" :key="`menu-${item.name}`" :parent-item="item"></side-menu-item>
            <menu-item v-else :name="getNameOrHref(item, true)" :key="`menu-${item.children[0].name}`"><common-icon :type="item.children[0].meta.icon || ''"/><span>{{ showTitle(item.children[0]) }}</span></menu-item>
          </template>
          <template v-else>
            <side-menu-item v-if="showChildren(item)" :key="`menu-${item.name}`" :parent-item="item"></side-menu-item>
            <menu-item v-else :name="getNameOrHref(item)" :key="`menu-${item.name}`"><common-icon :type="item.meta.icon || ''"/><span>{{ showTitle(item) }}</span></menu-item>
          </template>
        </template>
      </div>
    </Menu>
    <div class="menu-collapsed" v-show="collapsed" :list="menuList">
      <template v-for="item in menuList">
        <collapsed-menu v-if="item.children && item.children.length > 1" @on-click="handleSelect" hide-title :root-icon-size="rootIconSize" :icon-size="iconSize" :theme="theme" :parent-item="item" :key="`drop-menu-${item.name}`"></collapsed-menu>
        <Tooltip transfer v-else :content="showTitle(item.children && item.children[0] ? item.children[0] : item)" placement="right" :key="`drop-menu-${item.name}`">
          <a @click="handleSelect(getNameOrHref(item, true))" class="drop-menu-a" :style="{textAlign: 'center'}"><common-icon :size="rootIconSize" :color="textColor" :type="item.meta.icon || (item.children && item.children[0].meta.icon)"/></a>
        </Tooltip>
      </template>
    </div>
  </div>
</template>
<script>
import SideMenuItem from './side-menu-item.vue';
import CollapsedMenu from './collapsed-menu.vue';
import mixin from './mixin';

const getUnion = function (arr1, arr2) {
  return Array.from(new Set([...arr1, ...arr2]));
};

export default {
  name: 'SideMenu',
  mixins: [mixin],
  components: {
    SideMenuItem,
    CollapsedMenu
  },
  props: {
    menuList: {
      type: Array,
      default() {
        return [];
      }
    },
    collapsed: {
      type: Boolean
    },
    theme: {
      type: String,
      default: 'primary'
    },
    rootIconSize: {
      type: Number,
      default: 20
    },
    iconSize: {
      type: Number,
      default: 16
    },
    accordion: Boolean,
    activeName: {
      type: String,
      default: ''
    }
    // openNames: {
    //   type: Array,
    //   default: () => []
    // }
  },
  data() {
    return {
      openedNames: []
    };
  },
  methods: {
    handleSelect(name) {
      this.$emit('on-select', name);
    },
    getOpenedNamesByActiveName(name) {
      return this.$route.matched.map(item => item.name).filter(item => item !== name);
    },
    updateOpenName(name) {
      this.openedNames = this.getOpenedNamesByActiveName(name);
    }
  },
  computed: {
    textColor() {
      return this.theme === 'light' ? '#fff' : '#495060';
    }
  },
  watch: {
    // activeName (name) {
    //   if (this.accordion) this.openedNames = this.getOpenedNamesByActiveName(name)
    //   else this.openedNames = getUnion(this.openedNames, this.getOpenedNamesByActiveName(name))
    // },
    // openNames (newNames) {
    //   this.openedNames = newNames
    // },
    openedNames() {
      this.$nextTick(() => {
        this.$refs.menu.updateOpened();
      });
    }
  },
  mounted() {
    // this.openedNames = getUnion(this.openedNames, this.getOpenedNamesByActiveName(name))
  }
};
</script>
<style lang="less">
@import './side-menu.less';
.layout-logo{
  width: 22%;
  height: 70px;
  float: left;
}
.layout-nav{
  width: 70%;
  margin: 0 auto;
  margin-right: 20px;
}
.classic{
    background-color: ghostwhite!important;
}
.side-menu-wrapper{
    background-color: ghostwhite!important;
}
.ivu-menu-item{
    background-color: ghostwhite!important;
    border-bottom:1px dashed gainsboro !important;
}
</style>
